export default "__VITE_ASSET__Bf1QVn_n__"